// extracted by mini-css-extract-plugin
module.exports = {"light_text":"styles_light_text__5_hl1","zero_margin_n_padding":"styles_zero_margin_n_padding__8joJr","contact_link":"styles_contact_link__CIrnc"};